module.exports = __webpack_public_path__ + "img/about/80243-016.png";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-016.png
// module id = 26
// module chunks = 0